class TestPagesModalController {
    constructor(TestPagesServiceApi) {
        this.$onInit = () => {
            this.showLoadingSpinner = true;
            this.testPageTraceId = this.resolve.testPageTraceId;
            this.TestPagesServiceApi.getTestPageDetails(this.testPageTraceId).then((response) => {
                this.testPageDetails = response.data;
                this.showLoadingSpinner = false;
            });
        };
        this.closeDialog = () => {
            this.dismiss();
        };
        this.TestPagesServiceApi = TestPagesServiceApi;
    }
}
angular.module('app').component('testPagesModal', {
    bindings: {
        resolve: '<', // ITestPagesModalResolve
        dismiss: '&'
    },
    templateUrl: 'scripts/app/partials/TestPages/TestPagesModal/test-pages-modal.tpl.html',
    controllerAs: 'vm',
    controller: TestPagesModalController
});
